/*
 * TODO: move non-home-page-specific functions to scripts.js
 */

const $j = jQuery.noConflict();
let mode = 'desktop';

/* Store the window width */
let windowWidth = $j(window).width();
let windowHeight = $j(window).height();

function toggleLabel() {
  if (windowWidth <= 690 && $j('.menu-toggle').html() === 'more') {
    $j('.menu-toggle').html('menu');
  } else if (windowWidth > 690 && $j('.menu-toggle').html() === 'menu') {
    $j('.menu-toggle').html('more');
  }
}

function adjustFooter(adjustHeight) {
  let tilesHeight = 0;

  if (mode === 'desktop') {
    tilesHeight = $j('#panel-one').height();
    tilesHeight += $j('#panel-four').height();
  } else if (mode === 'tablet') {
    tilesHeight = $j('#panel-one').height();
    tilesHeight += $j('#panel-three').height();
    tilesHeight += $j('#panel-five').height();
  } else if (mode === 'mobile') {
    tilesHeight = $j('#panel-one').height();
    tilesHeight += $j('#panel-two').height();
    tilesHeight += $j('#panel-three').height();
    tilesHeight += $j('#panel-four').height();
    tilesHeight += $j('#panel-five').height();
    tilesHeight += $j('#panel-six').height();
  } else {
    // console.log('footer position error, invalid mode');
  }
  // console.log('adjust height: ' + parseInt(adjustHeight, 10));
  // console.log('tiles height: ' + parseInt(tilesHeight, 10));
  const footerTop = parseInt(adjustHeight, 10) + parseInt(tilesHeight, 10);
  $j('#colophon').css('top', `${footerTop}px`);

  $j('#colophon').width(windowWidth);
}

function removePanelClasses() {
  $j('#panel-one').removeClass('original-panel-one');
  $j('#panel-one').removeClass('original-panel-three');
  $j('#panel-two').removeClass('original-panel-one');
  $j('#panel-two').removeClass('original-panel-two');
  $j('#panel-two').removeClass('original-panel-three');
  $j('#panel-three').removeClass('original-panel-two');
  $j('#panel-three').removeClass('original-panel-three');
  $j('#panel-four').removeClass('original-panel-four');
  $j('#panel-four').removeClass('original-panel-six');
  $j('#panel-five').removeClass('original-panel-four');
  $j('#panel-five').removeClass('original-panel-five');
  $j('#panel-five').removeClass('original-panel-six');
  $j('#panel-six').removeClass('original-panel-five');
  $j('#panel-six').removeClass('original-panel-six');
}

function adjustTiles() {
  if (($j(window).width() >= 810 && mode !== 'desktop')
            || ($j(window).width() < 810 && $j(window).width() >= 640 && mode !== 'tablet')
            || ($j(window).width() < 640 && mode !== 'mobile')) {
    const tempHtml1 = $j('.original-panel-one').html();
    const tempHtml2 = $j('.original-panel-two').html();
    const tempHtml3 = $j('.original-panel-three').html();
    const tempHtml4 = $j('.original-panel-four').html();
    const tempHtml5 = $j('.original-panel-five').html();
    const tempHtml6 = $j('.original-panel-six').html();
    if ($j(window).width() >= 810 && mode !== 'desktop') {
      $j('#panel-one').html(tempHtml1);
      $j('#panel-two').html(tempHtml2);
      $j('#panel-three').html(tempHtml3);
      $j('#panel-four').html(tempHtml4);
      $j('#panel-five').html(tempHtml5);
      $j('#panel-six').html(tempHtml6);
      removePanelClasses();
      $j('#panel-one').addClass('original-panel-one');
      $j('#panel-two').addClass('original-panel-two');
      $j('#panel-three').addClass('original-panel-three');
      $j('#panel-four').addClass('original-panel-four');
      $j('#panel-five').addClass('original-panel-five');
      $j('#panel-six').addClass('original-panel-six');
      mode = 'desktop';
    } else if ($j(window).width() >= 640 && mode !== 'tablet') {
      $j('#panel-one').html(tempHtml1);
      $j('#panel-two').html(tempHtml3);
      $j('#panel-three').html(tempHtml2);
      $j('#panel-four').html(tempHtml6);
      $j('#panel-five').html(tempHtml4);
      $j('#panel-six').html(tempHtml5);
      removePanelClasses();
      $j('#panel-one').addClass('original-panel-one');
      $j('#panel-two').addClass('original-panel-three');
      $j('#panel-three').addClass('original-panel-two');
      $j('#panel-four').addClass('original-panel-six');
      $j('#panel-five').addClass('original-panel-four');
      $j('#panel-six').addClass('original-panel-five');
      mode = 'tablet';
    } else if (mode !== 'mobile') {
      $j('#panel-one').html(tempHtml3);
      $j('#panel-two').html(tempHtml1);
      $j('#panel-three').html(tempHtml2);
      $j('#panel-four').html(tempHtml4);
      $j('#panel-five').html(tempHtml5);
      $j('#panel-six').html(tempHtml6);
      removePanelClasses();
      $j('#panel-one').addClass('original-panel-three');
      $j('#panel-two').addClass('original-panel-one');
      $j('#panel-three').addClass('original-panel-two');
      $j('#panel-four').addClass('original-panel-four');
      $j('#panel-five').addClass('original-panel-five');
      $j('#panel-six').addClass('original-panel-six');
      mode = 'mobile';
    }
  }
}

function adjustPage() {
  const menuHeight = $j('#top-rod').height();
  let admindBarHeight = 0;
  let extraMenuHeight = 0;
  let adjustHeight = 0;
  windowHeight = $j(window).height();

  if ($j('body.admin-bar').length > 0) {
    admindBarHeight = parseInt($j('#wpadminbar').height(), 10);
  }

  if ($j('.home-menu-top-nav-container.bubble').css('display') !== 'none') {
    extraMenuHeight = parseInt(menuHeight, 10);
  }

  adjustHeight = menuHeight + adjustHeight + admindBarHeight + extraMenuHeight;
  const newTilesAreaHeight = windowHeight - adjustHeight;
  // console.log('newTilesAreaHeight: ' + newTilesAreaHeight);

  $j('#page.home').height(newTilesAreaHeight);
  $j('#page.home').css('top', `${adjustHeight.toString()}px`);

  adjustFooter(adjustHeight);
}

$j(() => {
  toggleLabel();
  $j(window).resize(() => {
    if ($j(window).width() !== windowWidth
                || $j(window).height() > windowHeight + 5
                || $j(window).height() < windowHeight - 5) {
      // Update the window width for next time
      windowWidth = $j(window).width();
      windowHeight = $j(window).height();

      // home page only
      //
      if ($j('#page.home').length > 0) {
        // console.log('resize handler');
        adjustTiles();
        adjustPage();
      }
      // all pages - menu/more
      //
      toggleLabel();
    }
  });

  if ($j('#page.home').length > 0) {
    // console.log('ready and home page');
    adjustTiles();
    adjustPage();

    $j('.home-menu-toggle').click(() => {
      // console.log('home menu toggle click');
      adjustPage();
    });
  }
});
